import React from 'react';
import { FunctionComponent } from 'react';
import Loader from 'react-loader-spinner';

import { ISubmitButtonProps } from './types';
import { useApiRequestState } from '../../../../../utils/api.utils';

export const SubmitButton: FunctionComponent<ISubmitButtonProps> = ({
  apiKey,
  formName,
  text,
  styles,
  color,
  disabled = false,
}) => {
  const [showLoader] = useApiRequestState(apiKey);

  return (
    <>
      {!showLoader && (
        <button form={formName} type="submit" className={styles ? styles : 'btn btn-green'} disabled={disabled}>
          {text}
        </button>
      )}
      {showLoader && (
        <Loader type="TailSpin" color={color ? color : 'var(--theme-primary-color)'} height={30} width={30} />
      )}
    </>
  );
};
